import { useState } from "react";

import { useEffectOnceWhen } from "shared/lib/hooks";

import { useUser } from "@/hooks/use-global-context";
import { useSessionStorage } from "@/context/local-storage";
import { glencocoClientAPI } from "@/api/glencoco";

import { swallow } from "@/api/legacy-swallow";

export const useCircleAuthentication = () => {
  const user = useUser();
  const storage = useSessionStorage();
  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffectOnceWhen(() => {
    const loadAccessToken = async () => {
      if (user?.email) {
        const authenticationResponse = await swallow(
          glencocoClientAPI().circle.authenticateMember(user?.email)
        );

        if (
          authenticationResponse.status === 200 &&
          authenticationResponse.data.access_token
        ) {
          storage.circleSessionCreatedAt = new Date().toDateString();
          setAccessToken(authenticationResponse.data.access_token);
        }
      }
    };

    if (storage.circleSessionCreatedAt) {
      // Set an empty access token which indicates to CircleCommunitySidebar that
      // there's already an active circle session
      setAccessToken("");
    } else {
      void loadAccessToken();
    }
  }, user?.email);

  return accessToken;
};
